import { render, staticRenderFns } from "./HiveIcon.vue?vue&type=template&id=37ef4849"
import script from "./HiveIcon.vue?vue&type=script&lang=ts"
export * from "./HiveIcon.vue?vue&type=script&lang=ts"
import style0 from "./HiveIcon.vue?vue&type=style&index=0&id=37ef4849&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports